import {Component, OnInit, ViewContainerRef} from '@angular/core';
import {SharedService} from '../../../../services/shared-service/shared.service';
import {AnonymousService} from '../../../../services/anonymous-service';
import {Router} from '@angular/router';
import {ErrorService} from '../../../../util/error_service/error.service';
import {ToastService} from '../../../../util/toast-service/toast.service';

@Component({
  selector: 'app-manage-role',
  templateUrl: './manage-role.component.html',
  styleUrls: ['./manage-role.component.scss']
})
export class ManageRoleComponent implements OnInit {
  public pageTitle: string;
  public roles: any;

  constructor(public _sharedService: SharedService, public anonymousService: AnonymousService, public router: Router,
              public error: ErrorService, public toast: ToastService) {
    this.getRoles();
    this.pageTitle = 'Manage Role';
    this._sharedService.emitChange(this.pageTitle);
  }

  ngOnInit() {
  }


  // get roles
  getRoles() {
    this.anonymousService.getRoles().subscribe(
      response => {
        // console.log(response.data);
        this.roles = response.data;
      },
      err => {
        // console.log(err);
        const msg = this.error.errorHandlerWithText(this.getRoles, err);
        // console.log(msg);
      }
    )
  }

  editRole(id) {
    this.router.navigate(['admin/edit-role/', id ]);
  }

  deleteRole(id) {
    this.anonymousService.deletRole(id).subscribe(
      data => {
        // console.log(data);
        this.getRoles();
        this.toast.showSuccess('Role deleted successfully', 'Success');
      },
      err => {
        // console.log(err);
        const msg = this.error.errorHandlerWithText(this.deleteRole, err);
        this.toast.showError(msg.message, 'Error');
        // console.log(msg);
      }
    )
  }

}



// WEBPACK FOOTER //
// ./src/app/Dashboard/DashboardPages/Role management/manage-role/manage-role.component.ts